<template>
  <div>
    <div class="modal" tabindex="-1" role="dialog" id="view-imported-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="importedFieldOnModal && importedFieldOnModal.imported">
          <div class="modal-header">
            <h5 class="modal-title">Importação do campo {{ importedFieldOnModal.text }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table">
              <thead>
                <tr>
                  <th>CPF</th>
                  <th>Dado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(imported, index) in importedFieldOnModal.imported" :key="index">
                  <td>{{ imported[0] }}</td>
                  <td>{{ imported[1] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" role="dialog" id="resend-modal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Reenvio de documento</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class='row'>
              <div class='col-12 centered'>
                <h5>Para quem você deseja reenviar este lote?</h5>
                <p class='text-danger centered'>Esta operação não pode ser desfeita</p>
                <p class='centered mt-5'>Caso queira modificar a data limite de assinatura, basta informar a nova data no campo abaixo</p>
              </div>
            </div>
            <div class='row mb-5'>
              <div class='col-6 offset-3 centered'>
                <date-picker
                  v-if="signatureBatchToResend"
                  :only-date="true"
                  v-model="signatureBatchToResend.limit_date"
                  :output-format="'YYYY-MM-DD'"
                  :format="'YYYY-MM-DD'"
                  :formated="'YYYY-MM-DD'"
                  :auto-close="true"
                  :button-now-translation="'Hoje'"
                  :label="''"
                  :color="'#03a830'"
                ></date-picker>
              </div>
            </div>
            <div class='row'>
              <div class='col-4'>
                <button type="button" class="btn btn-primary btn-block" data-dismiss="modal" @click="confirmResend(0)">Para <b>quem não assinou</b></button>
              </div>
              <div class='col-4'>
                <button type="button" class="btn btn-secondary btn-block" data-dismiss="modal" @click="confirmResend(1)">Para <b>todos</b></button>
              </div>
              <div class='col-4'>
                <button type="button" class="btn btn-danger btn-block" data-dismiss="modal">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" role="dialog" id="sendModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Envio de Lote</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h3 class="centered">
              <b>Tem certeza que deseja enviar o Lote?</b>
            </h3>
            <div
              v-if="sendingBatch.id && sendingBatch.signature_document && sendingBatch.signature_document.opened_fields && sendingBatch.signature_document.opened_fields.length"
            >
              <p class="mt-5">Confirme os campos abertos para continuar</p>
              <table class="table">
                <thead>
                  <tr>
                    <th>Campo</th>
                    <th>Conteúdo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="field in sendingBatch.signature_document.opened_fields"
                    :key="field.id"
                  >
                    <td>{{ field.text }}</td>
                    <td>
                      <input type="text" class="form-control" v-model="field.content" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              v-if="sendingBatch.id && sendingBatch.signature_document && sendingBatch.signature_document.imported_fields && sendingBatch.signature_document.imported_fields.length"
            >
              <p class="mt-5">Faça o upload dos seguintes campos para continuar</p>
              <table class="table">
                <thead>
                  <tr>
                    <th>Campo</th>
                    <th>Conteúdo</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="field in sendingBatch.signature_document.imported_fields"
                    :key="field.id"
                  >
                    <td>{{ field.text }}</td>
                    <td>
                      <input
                        type="file"
                        class="form-control"
                        :id="'upload-field-' + field.id"
                        @change="fileUploaded(field)"
                      />
                    </td>
                    <td>
                      <button class="btn btn-success" @click="viewImported(field)">
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <button type="button" class="btn btn-success" @click="confirmSend">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
    <base-crud
      :ref="table"
      :crudName="crudName"
      :newText="newText"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="false"
      :enableView="true"
      :dataForm="dataForm"
      :detailUrl="detailUrl"
      :extra="extra"
      @send="send"
      @reSend="reSend"
      @cancel="cancel"
      @csv="csv"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data() {
    return {
      signatureBatchToResend: null,
      importedFieldOnModal: "",
      sendingBatch: "",
      detailUrl: "signatureBatch",
      error: "",
      crudName: "Lote de Assinaturas",
      newText: "Cadastrar Lote de Assinatura",
      table: "signatureBatchTable",
      columns: [
        "id",
        "name",
        "signature_document_id",
        "sent",
        "sent_date",
        "resend_counter",
        "actions"
      ],
      tableData: [
        "id",
        "name",
        "signature_document_id",
        "sent",
        "sent_date",
        "resend_counter"
      ],
      options: {
        sortIcon: {
          base: "space_fas fas",
          is: "fa-sort",
          up: "fa-sort-amount-up",
          down: "fa-sort-amount-down"
        },
        filterByColumn: true,
        debounce: 1000,
        sortable: ["id", "name", "signature_document_id", "resend_counter"],
        filterable: ["id", "name", "signature_document_id", "resend_counter"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "#",
          name: "Nome",
          signature_document_id: "Nome do documento",
          sent: "Enviado",
          sent_date: "Data do envio",
          resend_counter: "Contagem de Reenvios",
          actions: "Ações"
        },
        templates: {
          sent_date(h, row, index) {
            return row.sent_date
              ? moment(row.sent_date).format("DD/MM/YYYY hh:mm:ss")
              : "";
          },
          signature_document_id(h, row, index) {
            return row.signature_document ? row.signature_document.name : "";
          },
          sent(h, row, index) {
            if (row.sent_date) {
              return <span class="fa fa-check green"></span>;
            } else {
              return <span class="fa fa-times red"></span>;
            }
          }
        },
        requestFunction: function(data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["signature_document"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function(e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        }
      },
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-crud blue",
          title: "Enviar",
          name: "send",
          icon: "fas fa-paper-plane"
        },
        {
          id: 2,
          label: "",
          class: "btn btn-crud yellow",
          title: "Reenviar",
          name: "reSend",
          icon: "fas fa-envelope"
        },
        {
            id: 3,
            label: "",
            class: "btn btn-crud edit",
            title: "CSV",
            name: "csv",
            icon: "fas fa-file-excel"
        }
      ],
      endPoint: "signaturebatches/",
      dataForm: {}
    };
  },
  mounted() {
    $("#view-imported-modal").on("hidden.bs.modal", function(e) {
      $("#sendModal").modal("show");
    });
  },
  methods: {
    csv(props) {
      $("#page_loader").show();
      const self = this;
      const api = self.$store.state.api + "signaturebatches/extract/" + props.row.id;
      self.$http
          .post(api)
          .then(response => {
              window.open(
                  self.$store.getters.url +
                      "signaturebatches/download/" +
                      response.data,
                  "_blank"
              );
              $("#page_loader").hide();
          })
          .catch(error => {
            $("#page_loader").hide();
            self.$message("Erro", error.response.data, "error");
          });
    },
    viewImported(field) {
      this.importedFieldOnModal = field;
      $("#sendModal").modal("hide");
      $("#view-imported-modal").modal("show");
    },
    fileUploaded(field) {
      $("#page_loader").show();
      const self = this;

      const file = document.getElementById("upload-field-" + field.id).files[0];
      if (file) {
        const fd = new FormData();
        fd.append("file", file);
        fd.append("dateField", field.date_field);

        const api = self.$store.state.api + "readFields";
        self.$http
          .post(api, fd)
          .then(response => {
            field.imported = response.data.data;
            self.$message("Sucesso", "Dados importados com sucesso", "success");
            $("#page_loader").hide();
          })
          .catch(error => {
            self.$message("Erro", error.response.data, "error");
            $("#page_loader").hide();
          });
      }
    },
    send(props) {
      $("#page_loader").show();

      const self = this;
      const api =
        self.$store.state.api +
        "signaturebatches/" +
        props.row.id +
        "?with[]=signature_document.opened_fields&with[]=signature_document.imported_fields";
      self.$http
        .get(api)
        .then(response => {
          self.sendingBatch = response.data.data[0];
          $("#sendModal").modal("show");
          $("#page_loader").hide();
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
          $("#page_loader").hide();
        });
    },
    confirmSend() {
      $("#page_loader").show();

      const self = this;
      const api =
        self.$store.state.api + "signaturebatches/send/" + self.sendingBatch.id;

      self.$http
        .post(api, {
          opened_fields: self.sendingBatch.signature_document.opened_fields,
          imported_fields: self.sendingBatch.signature_document.imported_fields
        })
        .then(response => {
          console.log("hiding");

          $("#sendModal").modal("hide");
          self.$message("Sucesso", "Lote enviado com sucesso", "success");
          self.$refs.signatureBatchTable.$refs.table.refresh();
          $("#page_loader").hide();
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
          $("#page_loader").hide();
        });
    },
    reSend(props) {
      const self = this;
      $('#resend-modal').modal('show')
      self.signatureBatchToResend = props.row
    },
    confirmResend(signed){
      const self = this
      if(self.signatureBatchToResend.id){
        const api = self.$store.state.api + "signaturebatches/reSend/" + self.signatureBatchToResend.id;
        self.$http
          .post(api, {
            'signed': signed,
            'limit_date': self.signatureBatchToResend.limit_date
          })
          .then(response => {
            self.$message(
              "Sucesso",
              "Lote reenviado com sucesso",
              "success"
            );
            self.$refs.signatureBatchTable.$refs.table.refresh();
            $("#page_loader").hide();
          })
          .catch(error => {
            self.$message("Erro", error.response.data, "error");
            $("#page_loader").hide();
          });
      }
    },
    cancel(props) {
      $("#page_loader").show();
      const self = this;
      const api =
        self.$store.state.api + "signaturebatches/cancel/" + props.row.id;
      self.$http
        .get(api)
        .then(response => {
          self.$message("Sucesso", "Lote cancelado com sucesso", "success");
          self.$refs.signatureBatchTable.$refs.table.refresh();
          $("#page_loader").hide();
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    query: function(query) {
      let columns = {
        id: "id",
        name: "name",
        signature_document_id: "signature_document[name]",
        resend_counter: "resend_counter",
        sent_date: "sent_date"
      };
      let filters = "&is_detatched_sending=0&orderByDesc=id&is_multiple=0&";
      $.each(query, function(index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    }
  },
  components: {
    BaseCrud
  }
};
</script>


// WEBPACK FOOTER //
// src/components/SignatureBatch/Crud.vue